export default "__VITE_ASSET__DUeO6vuO__"